import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupScrollReveal()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  // Fade-in elements on scroll
  setupScrollReveal() {
    const els = this.element.querySelectorAll(".lp-fade")
    if (!els.length) return

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible")
            this.observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.15 }
    )

    els.forEach((el) => this.observer.observe(el))
  }

}
